import { Link, Navigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import { Button } from '../components/Button';

export function Welcome() {
  const { user } = useAuth();
  if (user) return <Navigate to="/dashboard" replace />;

  return (
    <div>
      <p style={{ color: 'var(--gold)', fontSize: 13, fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.12em', marginBottom: 16 }}>
        For UK grassroots parents
      </p>
      <h1 style={{ marginBottom: 16 }}>
        Your kid's football story. <em style={{ color: 'var(--gold)', fontStyle: 'italic' }}>Captured forever.</em>
      </h1>
      <p style={{ color: '#4A463F', fontSize: 18, lineHeight: 1.55, marginBottom: 28, maxWidth: 480 }}>
        Tap goals from the touchline. Voice-note the moments from the car. A real archive of every season your child plays.
      </p>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 12, maxWidth: 360 }}>
        <Link to="/signup" style={{ textDecoration: 'none' }}>
          <Button label="Create your account" style={{ width: '100%' }} />
        </Link>
        <Link to="/login" style={{ textDecoration: 'none' }}>
          <Button label="I already have an account" variant="ghost" style={{ width: '100%' }} />
        </Link>
      </div>

      <p style={{ color: 'var(--muted)', fontSize: 14, marginTop: 16 }}>
        Free to start. No card. No spam, ever.
      </p>
    </div>
  );
}
